import React, { useState } from 'react';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import SolutionSection from './SolutionSection';
import CredibilitySection from './CredibilitySection';
import FOMOSection from './FOMOSection';
import BenefitsSection from './BenefitsSection';
import SignupSection from './SignupSection';
import FAQSection from './FAQSection';
import FinalCTASection from './FinalCTASection';
import Footer from './Footer';

const NewsletterLanding: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleEmailSubmit = async (emailValue: string) => {
    try {
      const response = await fetch('https://newsletter-backend.qkrrjsdn971.workers.dev/api/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: emailValue }),
      });

      if (response.ok) {
        alert('구독이 완료되었습니다!');
        setEmail('');
      } else {
        alert('구독 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('구독 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <HeroSection onEmailSubmit={handleEmailSubmit} />
      <ProblemSection />
      <SolutionSection />
      <CredibilitySection />
      <FOMOSection />
      <BenefitsSection />
      <SignupSection onEmailSubmit={handleEmailSubmit} />
      <FAQSection />
      <FinalCTASection onEmailSubmit={handleEmailSubmit} />
      <Footer />
    </div>
  );
};

export default NewsletterLanding;
